import React from "react";

import { IProps } from "./interfaces";
import TokenField from "./TokenField";

const TokenTable = ({ tokens, saveToken, users, user, getToken, approveTranslation, sourceLanguage, status }: IProps) => (
    <div>
        {tokens.map(token => {
            const responsibleUser = token?.translationToken?.value
                ? users.find(user => user._id === token.translationToken?.user)
                : undefined;
            const approvedBy = token?.translationToken?.approvedBy || [];
            return (
                <TokenField
                    key={token._id}
                    token={token}
                    responsibleUser={responsibleUser}
                    user={user}
                    saveToken={saveToken}
                    getToken={getToken}
                    approvedBy={approvedBy}
                    approveTranslation={approveTranslation}
                    sourceLanguage={sourceLanguage}
                    status={status}
                />
            );
        })}
    </div>
);

export default TokenTable;

